<template>
  <div>
    <v-container fluid>
      <v-card elevation="0" class="">
        <v-card-title class="secondary--text font-weight-medium pt-5 py-0">
          <v-row justify="end" class="ma-0" no-gutters>
            <v-col cols="12">
              <h3 class="mx-3 my-2 primary--text">
                {{ $t("common.promotions") }}
              </h3>
            </v-col>
            <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer> -->
            <v-col cols="4">
              <v-text-field
                :label="$t('bookings.searchByLandlordOrProperty')"
                flat
                class="mx-2"
                dense
                outlined
                v-model="searchText"
              ></v-text-field>
            </v-col>
            <v-menu>
              <template #activator="{ on, attrs }">
                <v-btn class="ml-2" v-on="on" v-bind="attrs" icon>
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-list class="text-body-2">
                <v-list-item @click="openRightSideDrawer">
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-plus-circle </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("promotedLandlord.addPromotion") }}
                  </v-list-item-text>
                </v-list-item>
                <v-list-item @click="exportData">
                  <v-list-item-icon>
                    <v-icon color="success"> mdi-application-export </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("common.excel") }}
                  </v-list-item-text>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- <v-select
              :label="`Search By Current Status`"
              v-model="currentStatus"
              :items="['All', 'Active', 'Expired']"
              class="mx-1"
              outlined
              dense
            >
            </v-select> -->
            <!-- <add-button text="landlord.addNew" class="mt-n2" :action="openRightSideDrawer"/> -->
          </v-row>
        </v-card-title>
        <v-card-title class="secondary--text font-weight-medium my-0 py-0">
          <v-row class="mx-0 mb-4 px-0 bg">
            <v-expansion-panels flat accordion tile>
              <v-expansion-panel>
                <v-expansion-panel-header
                  color="#f2f2f2ef"
                  class="primary--text"
                >
                  {{ $t("common.moreFilter") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content color="#f2f2f2ef">
                  <v-form ref="filterForm">
                    <v-row>
                      <v-col class="my-0 py-0" cols="12" lg="3" md="6" sm="6">
                        <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="fromDate"
                              placeholder="Start Date"
                              append-icon="mdi-calendar"
                              outlined
                              hide-details
                              class="white my-2"
                              flat
                              dense
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="fromDate"
                            @input="menu1 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col class="my-0 py-0" cols="12" lg="3" md="6" sm="6">
                        <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="toDate"
                              placeholder="End Date"
                              append-icon="mdi-calendar"
                              outlined
                              hide-details
                              class="white my-2"
                              flat
                              dense
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="toDate"
                            @input="menu2 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col class="my-0 py-0" cols="12" lg="2" md="6" sm="6">
                        <v-select
                          label="Select Status"
                          class="my-2"
                          :items="activeFilters"
                          item-text="text"
                          item-value="value"
                          outlined
                          dense
                          v-model="status"
                        ></v-select>
                      </v-col>
                      <v-col class="my-0 py-0" cols="12" lg="4" md="6" sm="6">
                        <!-- <v-btn
                          elevation="0"
                          rounded
                          class="my-2 primary text-none"
                        >
                          {{ $t("common.applyFilter") }}
                        </v-btn> -->
                        <v-btn
                          elevation="0"
                          @click="clearALl"
                          color="primary"
                          class="mx-1 my-2 white--text text-none rounded-lg"
                        >
                          {{ $t("common.clear") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-card-title>
        <!-- <v-row class="mx-2">
            <v-col cols="6">

            </v-col>
            <v-col cols="2">
              <v-row>
              <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fromDate"
                  placeholder="Start Date"
                  append-icon="mdi-calendar"
                  outlined
                  class="mx-1 my-2"
                  flat
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fromDate"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
            </v-row>
            </v-col>
            <v-col cols="2">
              <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="toDate"
                  placeholder="End Date"
                  append-icon="mdi-calendar"
                  outlined
                  flat
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="toDate"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-col cols="2">
              <v-btn
              color="primary"
              dark
              @click="filterData">
              Filter
              </v-btn>
            </v-col>
          </v-row> -->
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          class="datatable mb-9"
          :headers="headers"
          id="promotionTable"
          :items="promotedLandlordLists"
          :no-data-text="noDataText[status]"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
        >
          <!-- :server-items-length="totalPromotedLandlord" -->
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  promotedLandlordLists
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>
          <template v-slot:[`item.promotionEndDate`]="{ item }">
            <p>
              {{
                item.promotionEndDate
                  ? dateFormat(new Date(parseInt(item.promotionEndDate)))
                  : "-"
              }}
            </p>
          </template>
          <template v-slot:[`item.promotionStartDate`]="{ item }">
            <p>
              {{
                item.promotionStartDate
                  ? dateFormat(new Date(parseInt(item.promotionStartDate)))
                  : "-"
              }}
            </p>
          </template>
          <template v-slot:[`item.property`]="{ item }">
            <p>
              {{
                $i18n.locale === "en"
                  ? item.property.nameEn
                  : item.property.nameAr
              }}
            </p>
          </template>
          <template v-slot:[`item.isExpired`]="{ item }">
            <v-chip v-if="item.status === 'PAID'" small color="primary">
              {{ !item.isExpired ? "Active" : "Expired" }}
            </v-chip>
            <v-chip v-else small color="primary">
              {{ !item.isExpired ? "Inactive" : "Expired" }}
            </v-chip>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip small color="primary">
              {{ $t(`status.${item.status}`) }}
            </v-chip>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-row class="mx-0">
              <v-icon color="red" @click="showDeleteDialog(item)">
                mdi-delete</v-icon
              >
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      menu1: false,
      menu2: false,
      currentStatus: "All",
      search: "",
      searchText: "",
      fromDate: "",
      toDate: "",
      isExpired: false,
      status: "ACTIVE",
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      promotedLandlordLists: [],
      totalPromotedLandlord: 10,
      activeFilters: [
        {
          text: "Active",
          value: "ACTIVE"
        },
        {
          text: "Inactive",
          value: "INACTIVE"
        },
        {
          text: "Expired",
          value: "EXPIRED"
        }
      ]
    };
  },
  computed: {
    noDataText() {
      return {
        ACTIVE: this.$t("promotions.noActivePromotions"),
        INACTIVE: this.$t("promotions.noInactivePromotions"),
        EXPIRED: this.$t("promotions.noExpiredPromotions")
      };
    },
    headers() {
      return [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "_id",
          width: 10
        },
        {
          text: this.$t("landlord.name"),
          align: "left",
          sortable: false,
          value: "landlord.user.firstName"
        },
        {
          text: this.$t("promotedLandlord.property"),
          align: "left",
          sortable: false,
          value: "property"
        },
        {
          text: this.$t("promotedLandlord.amount"),
          align: "left",
          sortable: false,
          value: "amount"
        },
        {
          text: this.$t("promotedLandlord.numberOfDays"),
          align: "left",
          sortable: false,
          value: "numberOfDays"
        },
        {
          text: this.$t("status.currentStatus"),
          align: "left",
          sortable: false,
          value: "isExpired"
        },
        {
          text: this.$t("status.paymentStatus"),
          align: "left",
          sortable: false,
          value: "status"
        },
        {
          text: this.$t("promotedLandlord.promotionStartDate"),
          align: "left",
          sortable: false,
          value: "promotionStartDate"
        },
        {
          text: this.$t("promotedLandlord.promotionEndDate"),
          align: "left",
          sortable: false,
          value: "promotionEndDate"
        }
      ].map(header => {
        header.align = "center";
        return header;
      });
    }
  },
  watch: {
    currentStatus() {},
    options() {
      this.limit =
        this.options.itemsPerPage !== -1
          ? this.options.itemsPerPage
          : this.totalPayments;
      this.skip =
        this.options.page * this.options.itemsPerPage -
        this.options.itemsPerPage;
    }
  },
  apollo: {
    getAllPromotions() {
      return {
        query: require("@/promotions/api/queries/get_all_promotions_query.graphql"),
        fetchPolicy: "no-cache",
        variables: () => ({
          input: {
            limit: 50,
            skip: 0
          },
          filter: {
            searchText: this.searchText,
            fromDate: this.fromDate,
            toDate: this.toDate,
            status: this.status
          }
        }),
        result({ data }) {
          // , loading, networkStatus, refetch
          this.promotedLandlordLists = this.$format.cloneVariable(
            data.getAllPromotions.promotions
          );
          this.totalPromotedLandlord = data.totalCount;
        }
      };
    }
  },
  mounted() {
    this.$root.$on("promotionTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
  },
  methods: {
    exportData() {
      this.$apollo.queries.getAllPromotions
        .refetch({
          input: {
            limit: 1000,
            skip: 0
          }
        })
        .then(response => {
          this.options.itemsPerPage = response.data.getAllPromotions.totalCount;
          this.promotedLandlordLists =
            response.data.getAllPromotions.promotions;
          setTimeout(() => {
            this.htmlToExcel("promotionTable", "promotion");
          }, 1000);
        });
    },
    showRightSideDrawer() {},
    clearALl() {
      this.$refs.filterForm.reset();
    },
    getPromotionsByDate() {},
    // filterData() {
    //   this.$apollo.queries.getAllPromotions.refetch({
    //     input: {
    //       limit: 50,
    //       skip: 0
    //     },
    //     filter: {
    //       searchText: this.searchText,
    //       fromDate: this.fromDate,
    //       toDate: this.toDate,
    //       isExpired: this.isExpired
    //     }
    //   });
    // },
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    openRightSideDrawer() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    showDeleteDialog(item) {
      this.$root.$emit("deleteDialog", { dialog: true, item: item });
    }
  },
  beforeDestroy() {
    this.$root.$off("promotionTable");
  }
};
</script>
<style scoped>
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
